import { E } from '@angular/cdk/keycodes';
import { Component, EventEmitter, Injectable, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { NgbDateParserFormatter, NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Converters } from '../../utils/converters.utils';

const I18N_VALUES: any = {
  it: {
    weekdays: ['Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa', 'Do'],
    months: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
    weekLabel: "set1",
  },
  en: {
    weekdays: ['Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa', 'Do'],
    months: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
    weekLabel: "set2",
  }
  // other languages you would support
};

// Define a service holding the language. You probably already have one if your app is i18ned. Or you could also
// use the Angular LOCALE_ID value
@Injectable()
export class I18n {
  language = 'it';
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {

  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10)
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : '';
  }
}


// Define custom service providing the months and weekdays translations
@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {
  constructor(private _i18n: I18n) { super(); }

  getWeekdayShortName(weekday: number): string { return I18N_VALUES[this._i18n.language].weekdays[weekday - 1]; }
  getWeekLabel(): string { return I18N_VALUES[this._i18n.language].weekLabel; }
  getWeekdayLabel(weekday: number): string { return I18N_VALUES[this._i18n.language].weekdays[weekday - 1]; }
  getMonthShortName(month: number): string { return I18N_VALUES[this._i18n.language].months[month - 1]; }
  getMonthFullName(month: number): string { return this.getMonthShortName(month); }
  getDayAriaLabel(date: NgbDateStruct): string { return `${date.day}-${date.month}-${date.year}`; }
}

@Component({
  selector: 'app-datepicker-default',
  templateUrl: './datepicker-default.component.html',
  styleUrls: ['./datepicker-default.component.scss'],
  providers:
    [I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
      { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
      { provide: ControlContainer, useExisting: NgForm }]  // define custom NgbDatepickerI18n provider
})
export class DatepickerDefaultComponent implements OnInit {
  @Input() model!: Date;
  @Input() label = true;
  @Input() placeholder!: string;
  @Input() required = false;
  @Input() name!: string;
  @Input() myForm!: NgForm;
  modelDateStruct?: NgbDateStruct;
  @Output() modelChange = new EventEmitter<Date>();
  constructor() { }

  ngOnInit(): void {
    if (this.model) {
      this.modelDateStruct = Converters.fromDateToNgbDateStruct(this.model);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.model.currentValue === undefined) {
      this.modelDateStruct = undefined;
    }
    else {
      this.modelDateStruct = Converters.fromDateToNgbDateStruct(this.model);
    }
  }

  // tslint:disable-next-line: typedef
  eventChange() {
    this.modelChange.emit(Converters.fromNgbDateStructToDateWithTimes(this.modelDateStruct!, '00:00'));
  }

}




